import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { finalize } from 'rxjs';
import { LicenceValidationLog } from '../../models/licence-validation-log';
import { PageMeta } from '../../models/page-meta';
import { ValidationLogsService } from '../../services/validation-logs/validation-logs';

@Component({
  selector: 'app-validation-logs',
  standalone: false,
  templateUrl: './validation-logs.html',
  styleUrls: ['./validation-logs.css']
})
export class ValidationLogs implements OnInit {
  logs: LicenceValidationLog[] = [];

  loading = false;
  search = '';
  organizationId = '';
  wasSuccessful = '';

  page = 1;
  size = 10;

  meta: PageMeta = {
    page: 1,
    size: 10,
    totalItems: 0,
    totalPages: 0
  };

  constructor(
    private validationLogsService: ValidationLogsService,
    private toastr: ToastrService,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.loadLogs();
  }

  loadLogs(): void {
    this.loading = true;

    this.validationLogsService
      .getLogs(
        this.page,
        this.size,
        this.organizationId,
        this.wasSuccessful,
        this.search
      )
      .pipe(finalize(() => {
        this.loading = false;
        this.cdr.detectChanges();
      }))
      .subscribe({
        next: response => {
          if (!response.success || !Array.isArray(response.data)) {
            this.logs = [];
            this.meta = this.createMeta(0);
            this.toastr.error(response.message || 'Unable to load validation logs.');
            this.cdr.detectChanges();
            return;
          }

          this.logs = response.data;
          this.meta = response.meta || this.createMeta(this.logs.length);
          this.cdr.detectChanges();
        },
        error: error => {
          this.logs = [];
          this.meta = this.createMeta(0);
          this.toastr.error(
            error?.error?.message ||
              error?.error?.error?.details ||
              'Unable to load validation logs.',
            'Validation Logs'
          );
          this.cdr.detectChanges();
        }
      });
  }

  applyFilters(): void {
    this.page = 1;
    this.loadLogs();
  }

  clearFilters(): void {
    this.search = '';
    this.organizationId = '';
    this.wasSuccessful = '';
    this.page = 1;
    this.loadLogs();
  }

  private createMeta(totalItems: number): PageMeta {
    return {
      page: this.page,
      size: this.size,
      totalItems,
      totalPages: Math.max(1, Math.ceil(totalItems / this.size))
    };
  }

  previousPage(): void {
    if (this.page <= 1) return;

    this.page--;
    this.loadLogs();
  }

  nextPage(): void {
    if (this.page >= this.meta.totalPages) return;

    this.page++;
    this.loadLogs();
  }
}
